import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainDemosComponent } from './components/pages/main-demos/main-demos.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { HomeFiveComponent } from './components/pages/home-five/home-five.component';
import { HomeSixComponent } from './components/pages/home-six/home-six.component';
import { ErrorComponent } from './components/pages/error/error.component';

const routes: Routes = [
  {path: '', component: MainDemosComponent},
  {path: 'home-one', component: HomeOneComponent},
  {path: 'home-two', component: HomeTwoComponent},
  {path: 'home-three', component: HomeThreeComponent},
  {path: 'home-four', component: HomeFourComponent},
  {path: 'home-five', component: HomeFiveComponent},
  {path: 'home-six', component: HomeSixComponent},
  // Here add new pages component

  {path: '**', component: ErrorComponent} // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
